/* ================================================================
   MAISON BLANC — THEME JAVASCRIPT
   ================================================================ */
(function () {
  'use strict';

  /* ── HELPERS ─────────────────────────────────────────────── */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const fmtMoney = cents => '$' + (cents / 100).toFixed(2);

  /* ── SCROLL: header shadow ───────────────────────────────── */
  const header = $('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── HERO zoom on load ───────────────────────────────────── */
  const hero = $('.hero');
  if (hero) setTimeout(() => hero.classList.add('hero--zooming'), 100);

  /* ── TOAST ───────────────────────────────────────────────── */
  const toastEl = $('#toast');
  let toastTimer;
  window.showToast = function (msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('show'), 3200);
  };

  /* ── CART DRAWER ─────────────────────────────────────────── */
  const cartDrawer = $('#cart-drawer');
  const cartOverlay = $('#cart-overlay');
  const cartClose = $('#cart-close');
  const cartBadges = $$('.cart-badge');

  window.openCart = function () {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchAndRenderCart();
  };
  window.closeCart = function () {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  $$('[data-cart-open]').forEach(btn => btn.addEventListener('click', window.openCart));
  cartOverlay?.addEventListener('click', window.closeCart);
  cartClose?.addEventListener('click', window.closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') window.closeCart(); });

  function updateBadges(count) {
    cartBadges.forEach(b => {
      b.textContent = count > 0 ? count : '';
      b.dataset.count = count;
    });
  }

  async function fetchAndRenderCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
      updateBadges(cart.item_count);
    } catch (e) { console.error('Cart fetch error', e); }
  }

  function renderCart(cart) {
    const itemsEl = $('#cart-items');
    const footEl = $('#cart-foot');
    const totalEl = $('#cart-total-price');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = `
        <div class="cart-empty">
          <p>Your bag is empty</p>
          <a href="/collections/all" class="btn btn--outline btn--sm" onclick="window.closeCart()">Explore Collections</a>
        </div>`;
      if (footEl) footEl.hidden = true;
      return;
    }

    const items = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__img">
          <a href="${item.url}">
            <img src="${item.featured_image?.url || ''}" alt="${item.title}" loading="lazy" style="width:80px;height:120px;object-fit:cover;background:var(--cream)">
          </a>
        </div>
        <div>
          <p class="cart-item__name">${item.product_title}</p>
          ${item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
          <div class="cart-item__qty">
            <button onclick="updateItem('${item.key}',${item.quantity - 1})" aria-label="Decrease">−</button>
            <span>${item.quantity}</span>
            <button onclick="updateItem('${item.key}',${item.quantity + 1})" aria-label="Increase">+</button>
          </div>
          <button class="cart-item__remove" onclick="updateItem('${item.key}',0)">Remove</button>
        </div>
        <div>
          <p class="cart-item__price">${fmtMoney(item.final_line_price)}</p>
        </div>
      </div>`).join('');

    itemsEl.innerHTML = items;
    if (footEl) { footEl.hidden = false; }
    if (totalEl) totalEl.textContent = fmtMoney(cart.total_price);
  }

  window.updateItem = async function (key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const cart = await res.json();
      renderCart(cart);
      updateBadges(cart.item_count);
    } catch (e) { console.error(e); }
  };

  /* ── ADD TO CART ─────────────────────────────────────────── */
  const productForm = $('#product-form');
  const atcBtn = $('#atc-btn');
  const stickyBtn = $('#sticky-atc-btn');

  async function addToCart(variantId) {
    if (!variantId) return;
    [atcBtn, stickyBtn].forEach(b => {
      if (b) { b.disabled = true; b.textContent = 'Adding…'; }
    });
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error();
      await fetchAndRenderCart();
      window.openCart();
      [atcBtn, stickyBtn].forEach(b => {
        if (b) { b.textContent = 'Added ✓'; }
      });
      setTimeout(() => {
        [atcBtn, stickyBtn].forEach(b => {
          if (b) { b.disabled = false; b.textContent = 'Add to Bag'; }
        });
      }, 2000);
    } catch {
      [atcBtn, stickyBtn].forEach(b => {
        if (b) { b.disabled = false; b.textContent = 'Add to Bag'; }
      });
      window.showToast('Could not add item — please try again');
    }
  }

  productForm?.addEventListener('submit', e => {
    e.preventDefault();
    const id = $('#variant-id')?.value;
    addToCart(id);
  });

  stickyBtn?.addEventListener('click', () => {
    const id = $('#variant-id')?.value;
    addToCart(id);
  });

  /* ── PRODUCT GALLERY ─────────────────────────────────────── */
  const thumbs = $$('.gallery-thumb');
  const mainImg = $('#gallery-main-img');
  const prevBtn = $('#gallery-prev');
  const nextBtn = $('#gallery-next');
  let currentIdx = 0;

  // Parse images from embedded JSON
  let productImages = [];
  const productJSON = document.getElementById('product-json');
  if (productJSON) {
    try {
      const data = JSON.parse(productJSON.textContent);
      productImages = data.images || [];
    } catch (e) {}
  }

  function setImage(idx) {
    const max = Math.max(thumbs.length, productImages.length) - 1;
    currentIdx = Math.max(0, Math.min(idx, max));
    thumbs.forEach((t, i) => t.classList.toggle('active', i === currentIdx));
    if (mainImg && productImages[currentIdx]) {
      const src = productImages[currentIdx].src
        .replace(/(\.[a-z]+)(\?.*)?$/, '_1200x$1');
      mainImg.style.opacity = '.5';
      mainImg.src = src;
      mainImg.onload = () => { mainImg.style.opacity = '1'; };
    }
  }

  thumbs.forEach((t, i) => t.addEventListener('click', () => setImage(i)));
  prevBtn?.addEventListener('click', () => setImage(currentIdx - 1));
  nextBtn?.addEventListener('click', () => setImage(currentIdx + 1));

  // Swipe
  let touchX = 0;
  mainImg?.parentElement?.addEventListener('touchstart', e => { touchX = e.touches[0].clientX; }, { passive: true });
  mainImg?.parentElement?.addEventListener('touchend', e => {
    const dx = touchX - e.changedTouches[0].clientX;
    if (Math.abs(dx) > 44) dx > 0 ? setImage(currentIdx + 1) : setImage(currentIdx - 1);
  }, { passive: true });

  /* ── VARIANT SELECTION ───────────────────────────────────── */
  let productData = null;
  if (productJSON) {
    try { productData = JSON.parse(productJSON.textContent); } catch (e) {}
  }

  let selectedOptions = {};
  const variantIdInput = $('#variant-id');
  const priceEl = $('#product-price');
  const compareEl = $('#product-compare-price');
  const selectedColorLabel = $('#selected-color');
  const selectedSizeLabel = $('#selected-size');

  // Color swatches
  $$('.swatch[data-option]').forEach(sw => {
    sw.addEventListener('click', function () {
      const opt = this.dataset.option;
      const val = this.dataset.value;
      $$('.swatch[data-option="' + opt + '"]').forEach(s => s.classList.remove('active'));
      this.classList.add('active');
      selectedOptions[opt] = val;
      if (selectedColorLabel) selectedColorLabel.textContent = val;
      resolveVariant();
    });
  });

  // Size buttons
  $$('.size-btn').forEach(btn => {
    if (btn.classList.contains('sold-out')) return;
    btn.addEventListener('click', function () {
      const opt = this.dataset.option;
      $$('.size-btn[data-option="' + opt + '"]').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      selectedOptions[opt] = this.dataset.value;
      if (selectedSizeLabel) selectedSizeLabel.textContent = this.dataset.value;
      resolveVariant();
    });
  });

  function resolveVariant() {
    if (!productData) return;
    const match = productData.variants.find(v =>
      productData.options.every((opt, i) =>
        selectedOptions[opt] ? v['option' + (i + 1)] === selectedOptions[opt] : true
      )
    );
    if (!match) return;
    if (variantIdInput) variantIdInput.value = match.id;

    // Price
    if (priceEl) {
      priceEl.textContent = fmtMoney(match.price);
      priceEl.classList.toggle('product-price-sale', match.compare_at_price > match.price);
    }
    if (compareEl) {
      if (match.compare_at_price > match.price) {
        compareEl.textContent = fmtMoney(match.compare_at_price);
        compareEl.style.display = '';
      } else compareEl.style.display = 'none';
    }

    // ATC state
    const available = match.available;
    [atcBtn, stickyBtn].forEach(b => {
      if (!b) return;
      b.disabled = !available;
      b.textContent = available ? 'Add to Bag' : 'Sold Out';
    });

    // URL
    const url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url.toString());

    // Gallery image
    if (match.featured_image) {
      const imgIdx = productImages.findIndex(img => img.id === match.featured_image.id);
      if (imgIdx !== -1) setImage(imgIdx);
    }
  }

  /* ── ACCORDION ───────────────────────────────────────────── */
  $$('.accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', function () {
      const item = this.closest('.accordion__item');
      const isOpen = item.classList.contains('open');
      // Close all in same accordion
      this.closest('.accordion')?.querySelectorAll('.accordion__item.open').forEach(i => {
        if (i !== item) i.classList.remove('open');
      });
      item.classList.toggle('open', !isOpen);
      this.setAttribute('aria-expanded', !isOpen);
    });
  });

  /* ── WISHLIST ────────────────────────────────────────────── */
  let wishlist = JSON.parse(localStorage.getItem('mb-wishlist') || '[]');

  $$('[data-wishlist-toggle]').forEach(btn => {
    const id = parseInt(btn.dataset.wishlistToggle);
    if (wishlist.includes(id)) btn.classList.add('wishlisted');

    btn.addEventListener('click', e => {
      e.preventDefault();
      const i = wishlist.indexOf(id);
      if (i === -1) { wishlist.push(id); btn.classList.add('wishlisted'); window.showToast('Saved to wishlist'); }
      else { wishlist.splice(i, 1); btn.classList.remove('wishlisted'); window.showToast('Removed from wishlist'); }
      localStorage.setItem('mb-wishlist', JSON.stringify(wishlist));
    });
  });

  /* ── SIZE GUIDE MODAL ────────────────────────────────────── */
  const sizeGuideOverlay = $('#size-guide-overlay');
  $$('[data-size-guide-open]').forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault();
      sizeGuideOverlay?.classList.add('open');
    });
  });
  $$('[data-size-guide-close]').forEach(el => {
    el.addEventListener('click', () => sizeGuideOverlay?.classList.remove('open'));
  });
  sizeGuideOverlay?.addEventListener('click', e => {
    if (e.target === sizeGuideOverlay) sizeGuideOverlay.classList.remove('open');
  });

  /* ── MOBILE NAV ──────────────────────────────────────────── */
  const mobileNav = $('#mobile-nav');
  const mobileNavOverlay = $('#mobile-nav-overlay');
  $$('[data-mobile-menu-open]').forEach(btn => {
    btn.addEventListener('click', () => mobileNav?.classList.add('open'));
  });
  $$('[data-mobile-menu-close]').forEach(btn => {
    btn.addEventListener('click', () => mobileNav?.classList.remove('open'));
  });
  mobileNavOverlay?.addEventListener('click', () => mobileNav?.classList.remove('open'));

  /* ── FILTER BAR ──────────────────────────────────────────── */
  $$('.filter-pill[data-filter]').forEach(pill => {
    pill.addEventListener('click', function () {
      const key = this.dataset.filter;
      const val = this.dataset.value;
      const url = new URL(window.location.href);
      if (this.classList.contains('active')) url.searchParams.delete(key);
      else url.searchParams.set(key, val);
      window.location = url.toString();
    });
  });

  $('#sort-select')?.addEventListener('change', function () {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    window.location = url.toString();
  });

  /* ── SCROLL REVEAL ───────────────────────────────────────── */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-up');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
    $$('[data-reveal]').forEach(el => io.observe(el));
  }

  /* ── INIT CART COUNT ─────────────────────────────────────── */
  fetch('/cart.js')
    .then(r => r.json())
    .then(c => updateBadges(c.item_count))
    .catch(() => {});
})();
